import _typeof from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState, useRef } from "react";
import AwesomeIcon from "../AwesomeIcon";
import { faStars, faChevronDown, faTools, faMessageBot, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
var ToolCallsSection = function ToolCallsSection(_ref) {
  var toolCalls = _ref.toolCalls,
    messageId = _ref.messageId;
  var _useState = useState(false),
    isExpanded = _useState[0],
    setIsExpanded = _useState[1];
  var _useState2 = useState(null),
    expandedToolCall = _useState2[0],
    setExpandedToolCall = _useState2[1];
  var toolCallsRef = useRef(null);

  // Close tool calls section when clicking outside
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (toolCallsRef.current && !toolCallsRef.current.contains(event.target)) {
        setIsExpanded(false);
        setExpandedToolCall(null);
      }
    };
    if (isExpanded) {
      document.addEventListener("mousedown", handleClickOutside);
      return function () {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isExpanded]);

  // Group tool calls by action execution and result pairs
  var groupedToolCalls = toolCalls.reduce(function (acc, toolCall) {
    if (toolCall.type === "TextMessage") {
      acc.push({
        execution: {
          id: toolCall.id,
          name: "assistant",
          arguments: {}
        },
        result: toolCall === null || toolCall === void 0 ? void 0 : toolCall.content,
        type: "assistant"
      });
    }
    if (toolCall.type === "ActionExecutionMessage") {
      var resultMessage = toolCalls.find(function (tc) {
        return tc.type === "ResultMessage" && tc.actionExecutionId === toolCall.id;
      });
      acc.push({
        execution: toolCall,
        result: resultMessage,
        type: "tool"
      });
    }
    return acc;
  }, []);
  var getActionIcon = function getActionIcon(actionName) {
    switch (actionName) {
      case "fallback_handler":
        return faMessageBot;
      case "formatClinicalOverview":
      case "getReportDetails":
        return faStars;
      default:
        return faTools;
    }
  };
  var getActionColor = function getActionColor(actionName) {
    switch (actionName) {
      case "fallback_handler":
        return "text-blue-600 dark:text-blue-400";
      case "formatClinicalOverview":
      case "getReportDetails":
        return "text-teal-600 dark:text-teal-400";
      default:
        return "text-gray-600 dark:text-gray-400";
    }
  };
  var formatActionName = function formatActionName(name) {
    return name.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
      return str.toUpperCase();
    }).replace("_", " ").trim();
  };
  var renderResult = function renderResult(result) {
    if (!result) return null;
    var content;
    try {
      if (typeof result.result === "string") {
        var parsed = JSON.parse(result.result);
        content = parsed;
      } else {
        content = result.result;
      }
    } catch (_unused) {
      content = result.result;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-2 p-2 bg-green-50 dark:bg-green-900/20 rounded-md border-l-4 border-green-400"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-2 mb-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-2 h-2 bg-green-500 rounded-full"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-xs font-medium text-green-700 dark:text-green-300"
    }, "Result")), /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-mono text-green-800 dark:text-green-200 whitespace-pre-wrap max-h-32 overflow-y-auto bg-white dark:bg-gray-800 p-2 rounded border"
    }, _typeof(content) === "object" ? JSON.stringify(content, null, 2) : String(content)));
  };
  if (!toolCalls || toolCalls.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    ref: toolCallsRef,
    className: "mt-2 w-full border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    },
    className: "w-full flex items-center justify-between p-2 text-left hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors rounded-t-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center space-x-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-2 rounded-md"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faTools,
    size: "xs",
    className: "text-gray-600 dark:text-gray-400"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center space-x-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-sm font-semibold text-gray-800 dark:text-gray-200"
  }, "Agent Actions"), /*#__PURE__*/React.createElement("span", {
    className: "ml-2 px-2 py-1 bg-teal-100 dark:bg-teal-900/50 text-teal-700 dark:text-teal-300 text-xs rounded-full font-medium"
  }, groupedToolCalls.length))), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isExpanded ? faChevronUp : faChevronDown,
    size: "sm",
    className: "text-gray-500 dark:text-gray-400 transition-transform"
  })), isExpanded && /*#__PURE__*/React.createElement("div", {
    className: "border-t border-gray-200 dark:border-gray-600"
  }, groupedToolCalls.map(function (group, index) {
    var execution = group.execution,
      result = group.result,
      type = group.type;
    var isExpanded = expandedToolCall === execution.id;
    return /*#__PURE__*/React.createElement("div", {
      key: execution.id,
      className: "border-b border-gray-100 dark:border-gray-700 last:border-b-0"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setExpandedToolCall(expandedToolCall === execution.id ? null : execution.id);
      },
      className: "w-full flex items-center justify-between p-2 text-left hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "px-2 rounded-md text-blue-600 dark:text-blue-400 bg-opacity-10"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: type === "assistant" ? faStars : faTools,
      size: "xs",
      className: "text-blue-600 dark:text-blue-400"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-sm font-medium text-gray-800 dark:text-gray-200"
    }, formatActionName(execution.name)), result && /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-2 h-2 bg-green-500 rounded-full"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-xs text-green-600 dark:text-green-400 font-medium"
    }, "Success"))))), /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: isExpanded ? faChevronUp : faChevronDown,
      size: "xs",
      className: "text-gray-500 dark:text-gray-400 transition-transform"
    })), isExpanded && (type === "assistant" ? /*#__PURE__*/React.createElement("div", {
      className: "px-4 pb-4 bg-gray-50 dark:bg-gray-800/50 text-xs"
    }, result) : /*#__PURE__*/React.createElement("div", {
      className: "px-4 pb-4 bg-gray-50 dark:bg-gray-800/50"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mb-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-2 mb-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-2 h-2 bg-blue-500 rounded-full"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-xs font-medium text-blue-700 dark:text-blue-300"
    }, "Arguments")), /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-mono text-gray-700 dark:text-gray-300 whitespace-pre-wrap max-h-32 overflow-y-auto bg-white dark:bg-gray-800 p-3 rounded border border-gray-200 dark:border-gray-600"
    }, JSON.stringify(execution.arguments || {}, null, 2))), result && renderResult(result))));
  })));
};
export default ToolCallsSection;